<template>
  <LecturerWtxh v-if="siteId == 116" />
  <LecturerDefault v-else />
</template>

<script>
import LecturerDefault from "./lecturerDefault.vue";
import LecturerWtxh from "./lecturerWtxh.vue";

export default {
  name: "LecturerContainer",
  components: {
    LecturerDefault,
    LecturerWtxh,
  },
  data() {
    return {
      siteId: null,
    };
  },
  created() {
    let info = localStorage.getItem("siteInfo");
    if (info) {
      this.siteId = JSON.parse(info).id;
    }
  },
};
</script>
